import MutualTransferAgreementService from './mutual-transfer-agreement.service';
import ServiceAgreementService from './service-agreement.service';
import PermitService from './permit.service';

export default {
  documentRegistry: ({ axios }) => ({
    mutualTransferAgreementService: new MutualTransferAgreementService({ axios }),
    serviceAgreementService: new ServiceAgreementService({ axios }),
    permitService: new PermitService({ axios }),
  }),
};
